function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ke_svg__a",
  strokeMiterlimit: 10,
  d: "M-28.6 47.5l1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 00-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h640v144H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#060",
  d: "M0 336h640v144H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "ke_svg__b",
  transform: "matrix(3 0 0 3 320 240)"
}, /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  stroke: "#000",
  xlinkHref: "#ke_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  xlinkHref: "#ke_svg__a"
}));

var _ref6 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(-1 0 0 1 640 0)",
  xlinkHref: "#ke_svg__b"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#b00",
  d: "M640.5 168H377c-9-24-39-72-57-72s-48 48-57 72H-.2v144H263c9 24 39 72 57 72s48-48 57-72h263.5V168z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "ke_svg__c",
  d: "M377 312c9-24 15-48 15-72s-6-48-15-72c-9 24-15 48-15 72s6 48 15 72"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(-1 0 0 1 640 0)",
  xlinkHref: "#ke_svg__c"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  transform: "matrix(3 0 0 3 320 240)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 4,
  ry: 6
}), /*#__PURE__*/React.createElement("path", {
  id: "ke_svg__d",
  d: "M1 5.8s4 8 4 21-4 21-4 21z"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "scale(-1)",
  xlinkHref: "#ke_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "scale(-1 1)",
  xlinkHref: "#ke_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "scale(1 -1)",
  xlinkHref: "#ke_svg__d"
}));

var SvgKe = function SvgKe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default SvgKe;